"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var _require = require('react-mentions'),
    MentionsInput = _require.MentionsInput,
    Mention = _require.Mention;

var PropTypes = require('prop-types');

var _ = require('lodash');

var classNames = require('classnames');

var SendCommentDefaultIcon = require('../icons/sendComment.svg.js');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var IconButton = require('../iconButton');

var Tooltip = require('../tooltip');

var InputWithMentions = /*#__PURE__*/function (_React$Component) {
  _inherits(InputWithMentions, _React$Component);

  var _super = _createSuper(InputWithMentions);

  function InputWithMentions(props) {
    var _this;

    _classCallCheck(this, InputWithMentions);

    _this = _super.call(this, props);

    _this.isButtonDisabled = function (newValue) {
      return _this.props.disabled || !newValue.trim();
    };

    var nextValue = props.initialValue || '';
    _this.state = {
      value: nextValue,
      plainTextValue: nextValue,
      disabledButton: _this.isButtonDisabled(nextValue),
      mentions: []
    };
    _this.container = undefined;
    _this.inputElement = React.createRef();
    var _this$props = _this.props,
        onChange = _this$props.onChange,
        onSubmit = _this$props.onSubmit,
        onBlur = _this$props.onBlur;

    _this.handleChange = function (event, newValue, newPlainTextValue, mentions) {
      _this.setState({
        value: newValue,
        plainTextValue: newPlainTextValue,
        mentions: mentions,
        disabledButton: _this.isButtonDisabled(newValue)
      });

      if (_.isFunction(onChange)) {
        onChange(newValue, newPlainTextValue, mentions);
      }
    };

    _this.handleSubmit = function () {
      if (!_this.state.disabled && _.isFunction(onSubmit)) {
        onSubmit(_this.state.value, _this.state.plainTextValue, _this.state.mentions);
        var emptyValue = '';

        _this.setState({
          value: emptyValue,
          disabledButton: _this.isButtonDisabled(emptyValue),
          mentions: [],
          plainTextValue: emptyValue
        });
      }
    };

    _this.handleBlur = function () {
      if (_.isFunction(onBlur)) {
        onBlur(_this.state.value, _this.state.plainTextValue, _this.state.mentions);
      }
    };

    _this.handleOnKeyPress = function (event) {
      if (_this.props.pressEnterToSubmit && event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();

        if (!_this.state.disabledButton) {
          _this.handleSubmit();
        }
      }
    };

    return _this;
  }

  _createClass(InputWithMentions, [{
    key: "focusTextArea",
    value: function focusTextArea() {
      var el = this.inputElement.current;
      el.focus();
      el.setSelectionRange(el.value.length, el.value.length);
      el.scrollTop = el.scrollHeight;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          initialValue = _this$props2.initialValue,
          readOnly = _this$props2.readOnly,
          focus = _this$props2.focus;

      if (initialValue !== prevProps.initialValue) {
        this.setState({
          value: initialValue,
          disabledButton: this.isButtonDisabled(initialValue),
          mentions: [],
          plainTextValue: initialValue
        });
      }

      if (!readOnly && prevProps.readOnly) {
        this.focusTextArea();
      }

      if (focus && !prevProps.focus) {
        this.focusTextArea();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          focus = _this$props3.focus,
          readOnly = _this$props3.readOnly;

      if (focus && !readOnly) {
        this.focusTextArea();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          dataHook = _this$props4.dataHook,
          getClassName = _this$props4.getClassName,
          placeholder = _this$props4.placeholder,
          disabled = _this$props4.disabled,
          readOnly = _this$props4.readOnly,
          limitHeight = _this$props4.limitHeight,
          data = _this$props4.data,
          renderSuggestion = _this$props4.renderSuggestion,
          showSubmitButton = _this$props4.showSubmitButton,
          sumbitButtonTooltip = _this$props4.sumbitButtonTooltip,
          trigger = _this$props4.trigger,
          submitIcon = _this$props4.submitIcon,
          displayTransform = _this$props4.displayTransform,
          allowSpaceInQuery = _this$props4.allowSpaceInQuery,
          appendSpaceOnAdd = _this$props4.appendSpaceOnAdd;
      var disabledButton = this.state.disabledButton;
      return /*#__PURE__*/React.createElement("div", {
        onKeyPress: this.handleOnKeyPress,
        "data-hook": dataHook
      }, /*#__PURE__*/React.createElement("div", {
        id: "suggestionPortal",
        ref: function ref(el) {
          _this2.container = el;
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames(getClassName('mentions-container'), {
          'mentions-container-readonly': readOnly,
          'mentions-container-disabled': disabled,
          'mentions-container-withButton': showSubmitButton,
          'mentions-container-limited': limitHeight
        })
      }, /*#__PURE__*/React.createElement(MentionsInput, {
        className: getClassName('mentions'),
        "data-hook": "input-with-mentions",
        onBlur: this.handleBlur,
        readOnly: readOnly,
        value: this.state.value,
        onChange: this.handleChange,
        suggestionsPortalHost: this.container,
        markup: "@{{__type__||__id__||__display__}}",
        disabled: disabled,
        placeholder: placeholder,
        inputRef: this.inputElement
      }, /*#__PURE__*/React.createElement(Mention, {
        type: "user",
        renderSuggestion: renderSuggestion,
        data: data,
        trigger: trigger,
        allowSpaceInQuery: allowSpaceInQuery,
        appendSpaceOnAdd: appendSpaceOnAdd,
        displayTransform: displayTransform
      })), showSubmitButton && !readOnly && /*#__PURE__*/React.createElement(Tooltip, {
        content: sumbitButtonTooltip,
        disabled: !sumbitButtonTooltip
      }, /*#__PURE__*/React.createElement(IconButton, {
        dataHook: "input-with-mentions-submit",
        onClick: this.handleSubmit,
        size: "small",
        disabled: disabledButton || disabled
      }, submitIcon))));
    }
  }]);

  return InputWithMentions;
}(React.Component);

InputWithMentions.displayName = displayNames.INPUT_WITH_MENTIONS; // todo:
// add disabled prop
// Add unit tests
// Add visual tests (take a look in search component)

InputWithMentions.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** Initial value in the input */
  initialValue: PropTypes.string,

  /** Make the textarea readOnly */
  readOnly: PropTypes.bool,

  /** Make the textarea disabled */
  disabled: PropTypes.bool,

  /** Limit the height of the textarea to */
  limitHeight: PropTypes.bool,

  /** callback for input change event - onChange(newValue, newPlainTextValue, mentions) => void */
  onChange: PropTypes.func,

  /** callback for submit button clicked event - onChange(value, plainText, mentions) => void */
  onSubmit: PropTypes.func,

  /** callback for focusing out the input */
  onBlur: PropTypes.func,

  /** show/hide submit button */
  showSubmitButton: PropTypes.bool,

  /** Should call onSubmit when the user click Enter */
  pressEnterToSubmit: PropTypes.bool,

  /** sumbit button tooltip element */
  sumbitButtonTooltip: PropTypes.node,

  /** Text on empty input */
  placeholder: PropTypes.string,

  /** which character should trigger the suggestions box */
  trigger: PropTypes.string,

  /** Query might contain a space character */
  allowSpaceInQuery: PropTypes.bool,

  /** Should add space after adding a suggestion to the input */
  appendSpaceOnAdd: PropTypes.bool,

  /** Data for the suggestions box - {id: string, display: string}[] */
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    display: PropTypes.string
  })),

  /** Suggestion name after was selected (id: string, display: string) => string */
  displayTransform: PropTypes.func,

  /** Suggestions box component renderer */
  renderSuggestion: PropTypes.func,

  /** Submit custom node */
  submitIcon: PropTypes.node,

  /** should focus the textarea */
  focus: PropTypes.bool
};
InputWithMentions.defaultProps = {
  initialValue: '',
  readOnly: false,
  disabled: false,
  limitHeight: false,
  focus: false,
  onChange: _.noop,
  onSubmit: _.noop,
  onBlur: _.noop,
  pressEnterToSubmit: false,
  showSubmitButton: true,
  placeholder: '',
  data: [],
  trigger: '@',
  allowSpaceInQuery: true,
  appendSpaceOnAdd: true,
  displayTransform: function displayTransform(id, display) {
    return "@".concat(display);
  },
  submitIcon: /*#__PURE__*/React.createElement(SendCommentDefaultIcon, null)
};
module.exports = compose(InputWithMentions);